import axios from "axios"

// "Utöka ditt skydd": olycksfallsförsäkring as an add-on on the new summary page.
// Spread into the page's Alpine data (SharedPaymentData / SaddleInsuranceData), which
// calls initAccidentUpsell() from init() and posts accident_insurance on save.
export default function(endpoint) {
    return {
        accident_endpoint: endpoint || null,
        accident_insurance: false,
        accident_available: false,
        accident_price: 0,
        accident_price_loading: false,
        accident_open: false,

        initAccidentUpsell() {
            if (!this.accident_endpoint) {
                return;
            }

            this.updateAccidentPrice();

            this.$watch(() => [this.payment_interval, this.start_date], () => {
                this.updateAccidentPrice();
            });
        },

        updateAccidentPrice() {
            this.accident_price_loading = true;

            clearTimeout(this.update_accident_price_timeout);
            this.update_accident_price_timeout = setTimeout(() => {
                axios.post(this.accident_endpoint, {
                    payment_interval: this.payment_interval,
                    start_date: this.start_date,
                }).then(response => {
                    this.accident_price = parseInt(response.data.price) || 0;

                    // No price means Focus won't insure the customer — never offer it without one.
                    this.accident_available = this.accident_price > 0;

                    if (!this.accident_available) {
                        this.accident_insurance = false;
                    }
                }).catch(error => {
                    // Keep the last known price, e.g. while a start date is half-typed.
                    console.error(error);
                }).finally(() => {
                    this.accident_price_loading = false;
                });
            }, 250);
        },

        // Main insurance plus the add-on when chosen, for the summary totals.
        totalPrice() {
            return (parseInt(this.price) || 0) + (this.accident_insurance ? this.accident_price : 0);
        },

        totalPriceLoading() {
            return this.price_loading || (this.accident_insurance && this.accident_price_loading);
        },
    }
}
